import './address-info-tooltip.scss';
import React from 'react';

interface InfoTooltipProps {
    header: string;
    subHeader: string;
    description: string;
}

export const AddressInfoTooltip: React.FC<InfoTooltipProps> = ({ header, subHeader, description }) => {

    return <div className={'info-tooltip'}>
        <div className={'info-header'}>{header}</div>
        <div className={'info-sub-header'}>{subHeader}</div>
        <div className={'info-description'}>{description}</div>
    </div>;
};